import React from "react";
import { Link, useParams } from "react-router-dom";

interface LogoProps {
  src: string;
  alt?: string;
  height?: number;
  className?: string;
  classNameImg?: string;
}

const Logo: React.FC<LogoProps> = ({
  src,
  alt = "Logo",
  height = 32,
  className = "",
  classNameImg = "",
}) => {
  const { locale, menuId, branchId, typeMenu } = useParams();
  const hasMenuId = Boolean(menuId);

  const to =
    hasMenuId && menuId
      ? locale
        ? `/${locale}/menu/${menuId}/${branchId}/${typeMenu}/about-us`
        : `/menu/${menuId}/${branchId}/${typeMenu}/about-us`
      : locale
        ? `/${locale}/me-qr/${branchId}/${typeMenu}/about-us`
        : `/me-qr/${branchId}/${typeMenu}/about-us`;

  return (
    <Link
      to={to}
      className={`d-flex align-items-center ${className}`}
      style={{ height }}
    >
      <img
        src={src}
        alt={alt}
        className={`d-block h-100 w-auto ${classNameImg}`}
      />
    </Link>
  );
};

export default Logo;
